import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import { callApi } from '../../utils/apiCall';
import { hasFeatureAccess } from '../../utils/featurePermission';
import { updateError } from './user';

// ----------------------------------------------------------------

const initialState = {
    emailsCounter: ''
};

export const slice = createSlice({
    name: 'emailCounter',
    initialState,
    reducers: {
        setEmailsCounter(state, action) {
            state.emailsCounter = action.payload;
        },
    }
});

export const { setEmailsCounter } = slice.actions;

export default slice.reducer;

export function emailCounter(practiceId) {
    return async () => {
        if (!hasFeatureAccess('email-inbox')) return null;
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/inbox/threads/?fields={}&with_replies=${true}&is_unread=${true}`);
            if (response.status === 200) {
                dispatch(slice.actions.setEmailsCounter(response.data));
            }
            // dispatch(slice.actions.endLoading());
        } catch (error) {
            // dispatch(slice.actions.endLoading());
            dispatch(updateError({ message: error?.message, success: false }));
        }
    };
}